<div class="container-bg">
  <div class="container py-4">
    <div class="row">
      @for (additional of additionals; track $index) {
        <div class="col-12 col-md-4  {{ $index > 0 ? 'border-left' : '' }} my-2 d-md-block d-flex">
          <div class="row justify-content-center">
            <div
              class="icon col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-2 col-2 d-flex align-items-center justify-content-center">
              <span class="material-symbols-outlined">{{ additional.icon }}</span>
            </div>
            <div
              class="info col-xxl-10 col-xl-10 col-lg-10 col-md-12 col-sm-10 col-10 d-flex flex-column justify-content-center">
              <h2 class="txt_additional fw-600">{{ additional.title }}</h2>
              <span class="txt_button">{{ additional.description }}</span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
